import React from 'react';

function ContactSection() {
  const email = 'daughtersenterprise29@gmail.com';
  const whatsappNumber = '+91 92175 43325';
  const whatsappLink = 'https://wa.me/919217543325';
  const address = '2/2 Babarpur, Prem Gali, Shahdara, Delhi-110032';
  const mapsLink = 'https://maps.app.goo.gl/C7GR4KJZDSrsPrCF9';
  const embedMap =
    'https://www.google.com/maps?q=Daughters%20Enterprise%2C%202%2F2%20Babarpur%2C%20Masjid%20Wali%20Gali%2C%20Shahdara%2C%20Delhi%2C%20110032&z=16&output=embed';

  return (
    <section className="tab-panel contact-panel">
      <span className="home-eyebrow">Contact Daughters Enterprise</span>
      <h2 className="tab-panel-title">Bulk inquiries, direct support, and trusted service.</h2>
      <p className="tab-panel-text contact-intro">
        Daughters Enterprise focuses on quality ingredients, clear communication, and reliable
        customer support. Reach out for product questions, bulk inquiries, or location details.
      </p>

      <div className="contact-grid">
        <div className="contact-card">
          <h3 className="contact-card-title">Email</h3>
          <a className="contact-card-link" href={`mailto:${email}`}>
            {email}
          </a>
        </div>

        <div className="contact-card">
          <h3 className="contact-card-title">WhatsApp</h3>
          <a className="contact-card-link" href={whatsappLink} target="_blank" rel="noreferrer">
            {whatsappNumber}
          </a>
        </div>

        <div className="contact-card contact-card-wide">
          <h3 className="contact-card-title">Address</h3>
          <p className="contact-card-text">{address}</p>
        </div>

        <div className="contact-card contact-card-wide map-card">
          <div className="map-card-header">
            <div>
              <h3 className="contact-card-title">Google Maps</h3>
              <p className="contact-card-text">Tap the preview to open the location in Google Maps.</p>
            </div>
            <a className="map-open-link" href={mapsLink} target="_blank" rel="noreferrer">
              Open Map
            </a>
          </div>

          <div className="map-preview">
            <iframe
              title="Daughters Enterprise location"
              src={embedMap}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <a
              className="map-preview-overlay"
              href={mapsLink}
              target="_blank"
              rel="noreferrer"
              aria-label="Open Daughters Enterprise in Google Maps"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
